import { useTranslate } from "@/helper/translate";
import Select from "react-select";

type DropdownProps<T> = {
  source: T[];
  value: string | number | undefined | null;
  onChange: (value: string | number) => void;
  getLabel: (item: T) => string;
  getValue: (item: T) => string | number;
  className?: string;
  searchable?: boolean;
  disabled?: boolean;
};

export function Dropdown<T>({
  source,
  value,
  onChange,
  getLabel,
  getValue,
  className = "",
  searchable,
  disabled
}: DropdownProps<T>) {
  const options = source?.map((item) => ({
    label: getLabel(item),
    value: getValue(item)
  }));
  const selected = options?.find(opt => opt.value === value) ?? null;
  const { translate } = useTranslate();
  return (
    <Select
      className={className}
      classNamePrefix="react-select"
      options={options}
      isSearchable={searchable ?? false}
      value={selected}
      isDisabled={disabled}
      placeholder={translate("dd.Select")}
      styles={{
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? 'hsl(var(--react-select-hover))' : 'transparent',
          color: state.isFocused ? 'hsl(var(--react-select-hover-text))' : 'hsl(var(--react-select-text))',
          cursor: 'pointer'
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: 'hsl(var(--react-select-control))'
        }),
        menuList: (base) => ({
          ...base,
          backgroundColor: 'hsl(var(--react-select-control))'
        }),
        singleValue: (base) => ({
          ...base,
          color: 'hsl(var(--react-select-text))'
        }),
        placeholder: (base) => ({
          ...base,
          color: 'hsl(var(--react-select-text))'
        }),
        input: (base) => ({
          ...base,
          color: 'hsl(var(--react-select-text))'
        })
      }}
      onChange={(selected) => {
        if (selected) onChange(selected.value);
      }}
    />
  );
}
